import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_pharmacy/pharmacy-receiving")({
  beforeLoad: ({ context }) => guardRoute(context.me, "pharmacy-receiving"),
  component: Outlet,
});
